import { render, staticRenderFns } from "./transationlist.vue?vue&type=template&id=6d2336fd&"
import script from "./transationlist.vue?vue&type=script&lang=js&"
export * from "./transationlist.vue?vue&type=script&lang=js&"
import style0 from "./transationlist.vue?vue&type=style&index=0&id=6d2336fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports